import React, { Component } from 'react';
import { ButtonGroup, Button, Radio, Modal } from 'react-bootstrap';
import i18n from './Localization';
import ImgPrint from './Images/print.gif';

class PrintButton extends Component {
  state: {
    selected: number,
    show_modal: boolean
  };

  constructor() {
    super();
    this.state = {
      selected: 1,
      show_modal: false
    }
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  handleOptionChange(changeEvent) {
    this.setState({selected: parseInt(changeEvent.target.value, 10)});
  }

  open() {
    this.setState({show_modal: true});
  }

  close() {
    this.setState({show_modal: false});
  }

  print(printFn) {
    printFn(this.state.selected);
    this.close();
  }

  render(props) {
    var option_list = {
      "1": i18n.t("printOption01"),
      // "3": i18n.t("printOption03"),    //disabled option 3 because the filled in letters are not sent to the server
      "2": i18n.t("printOption02"),
      "4": i18n.t("printOption04"),
    };
    var options = [];
    for (var i in option_list) {
      if (!option_list.hasOwnProperty(i))
        continue;

      options.push(<Radio name="print" key={i} value={i}
        checked={this.state.selected == i}
        onChange={(x) => this.handleOptionChange(x)}>{option_list[i]}</Radio>);
    }

    return (
      <ButtonGroup>
      <Button className={"xwordjs-print-button"} title={i18n.t("printTitle")} bsSize="xsmall" onClick={this.open}>
        <img src={ImgPrint}/>
      </Button>
      <Modal show={this.state.show_modal} onHide={this.close} bsSize="small">
        <Modal.Header closeButton>
          <Modal.Title>{i18n.t("printTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="xwordjs-print-menu">
            {i18n.t("printDescription")}
            {options}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.print(this.props.onSelect)}>Print</Button>
        </Modal.Footer>
      </Modal>
      </ButtonGroup>);
  }
}

export default PrintButton;
